import { GroupWithPot } from 'app/hooks/useGroupsWithPot/types';
import * as yup from 'yup';

export interface CreatePotFormProps {
  companyId: string;
  onClose: () => void;
  onSuccess: () => void;
  predefinedGroup?: GroupWithPot;
}

export interface CreatePotFormFields {
  amount?: string;
  potManagers?: string[];
  group?: string;
}

export const createSchema = (maxBalance: number) =>
  yup.object({
    amount: yup
      .string()
      .required('Amount is required')
      .test('is-number', 'Enter a valid number', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num);
      })
      .test('min-balance', 'The amount must be greater than zero.', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num > 0;
      })
      .test('max-balance', 'Amount exceeds available balance', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num <= maxBalance;
      }),
    potManagers: yup.array().min(1, 'Select at least one pot manager'),
    group: yup.string().required('Group is required'),
  });

export const DEFAULT_CREATE_POT_FORM_DATA: CreatePotFormFields = {
  amount: undefined,
  potManagers: [],
  group: undefined,
};
